<template>
  <div class="page">
    <!-- 筛选 -->
    <div style="background: #fff">
      <div class="filter">
        <div class="filterName">类型：</div>
        <el-select
          v-model="operType"
          placeholder="请选择"
          class="titleSelect"
          style="width: 150px"
          size="small"
          clearable
          @change="getTableData"
        >
          <el-option
            v-for="(item, index) in operTypes"
            :key="index"
            :label="item"
            :value="item"
          />
        </el-select>
        <div class="filterName">筛选日期：</div>
        <el-date-picker
          v-model="comDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 220px"
          @change="getTableData"
        >
        </el-date-picker>
        <el-button
          type="warning"
          plain
          size="small"
          style="margin-left: 20px"
          @click="resetClick"
          >重置</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="operCategoryType.title" label="类型" width="120">
      </el-table-column>
      <el-table-column prop="operTime" label="时间" width="200">
      </el-table-column>
      <el-table-column
        prop="operation_info.create.create_user.user_name"
        label="操作人"
        width="80"
      >
        <template slot-scope="scope">
          {{
            scope.row.operation_info.create.create_user.user_name == ""
              ? "--"
              : scope.row.operation_info.create.create_user.user_name
          }}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="事件">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.content"
            placement="bottom"
          >
            <span>{{ scope.row.content }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <page
      :total="page.total"
      @change="changePage"
      style="margin-top: 22px"
    ></page>
  </div>
</template>

<script>
import page from "@/components/page.vue";
import { record, logfilter } from "@/api/purchaseApi.js";
import { getStaffList } from "@/api/shopStaff.js";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  components: {
    page,
  },
  data() {
    return {
      feedShop: null,
      value: "",
      options: [],
      input: "",
      page: {
        page: 1,
        pageSize: 12,
        total: 0,
      },
      params: {
        pageIndex: 1,
        pageSize: 100,
        keyword: "",
        shopId: this.$store.state.shopId,
        position: "",
        status: 1,
      },
      salerId: "",
      breederId: "",
      beauticianId: "",
      doctorId: "",
      salesList: [],
      doctorList: [],
      beauticianList: [], //美容师
      breederList: [], //饲养员
      tableData: [],
      comDate: "", //筛选日期
      operType: "", //操作类型
      operTypes: [],
    };
  },
  mounted() {
    this.getLogfilterData();
    this.getTableData();
  },
  methods: {
    //获取筛选
    getLogfilterData() {
      logfilter().then((res) => {
        if (res.code == 0) {
          this.operTypes = res.data;
        }
      });
    },
    //重置
    resetClick() {
      this.page.page = 1;
      (this.operType = ""), (this.comDate = "");
      this.getTableData();
    },
    //获取数据
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        operType: this.operType,
        petId: this.id,
      };
      if (this.comDate != "") {
        params.bgnDate = new Date(this.comDate[0]).getTime() / 1000;
        params.endDate = new Date(this.comDate[1]).getTime() / 1000;
      }
      record(params).then((res) => {
        if (res.code == 0) {
          console.log("操作记录", res);
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 734px;
  margin-top: 12px;
  font-size: 14px;

  .filter {
    height: 58px;
    display: flex;
    align-items: center;
    background: #fff;

    .sousuo {
      width: 153px;
      margin-right: 4px;
      margin-left: 16px;
    }

    .filterName {
      margin-left: 20px;
      margin-right: 4px;
    }
  }
}
</style>
